import styled from "styled-components";
import Box from "../box/Box";
import Button from "../button/Button";
export const StyledPaginationContainer = styled(Box).withConfig({ displayName: "StyledPaginationContainer_APC-7311-productShell", componentId: "sc-1xannsr" })({
    display: "inline-flex",
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
});
export const StyledLoadMoreButton = styled(Button).withConfig({ displayName: "StyledLoadMoreButton_APC-7311-productShell", componentId: "sc-11kuwoq" })(({ isVisible, variant }) => ({
    "&&": Object.assign({ visibility: isVisible ? "visible" : "hidden" }, (variant === "tertiary" && {
        border: "1px solid transparent",
        "&:disabled": {
            border: "1px solid transparent",
        },
    })),
}));
//# sourceMappingURL=LoadMoreButton.style.js.map